<template>
  <v-text-field 
    v-model="search"
    :label="$t('Global.Common.search')" 
    :hide-details="!help"
    :hint="help"
    :loading="loading || searchTimerId !== null"
    solo
    prepend-inner-icon="find_in_page"
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'SearchField',
  props: {
    help: {type: String, required: false}
  },
  data: () => ({
    search: '',
    loading: false,
    searchTimerId: null,
  }),
  watch: {
    search (value) {
      clearTimeout(this.searchTimerId)
      this.searchTimerId = setTimeout(async () => {
        this.$emit('search', value)
        this.searchTimerId = null
      }, 300)
    }
  },
}
</script>